import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { LayoutDashboard } from 'lucide-react';
import '../../styles/unified.css';

const Dashboard = () => {
  const { user } = useAuth0();

  return (
    <div className="page-container">
      <div className="page-header">
        <LayoutDashboard size={32} className="page-icon" />
        <h1 className="page-title">Dashboard</h1>
      </div>
      <div className="page-content">
        <p className="welcome-text">Welcome back, {user?.name}!</p>
        <p className="page-description">Your dashboard content will appear here.</p>
        
        {/* Add your dashboard widgets, stats, charts here */}
        <div className="dashboard-grid">
          <div className="dashboard-card">
            <h3>Quick Stats</h3>
            <p>Dashboard statistics coming soon...</p>
          </div>
          <div className="dashboard-card">
            <h3>Recent Activity</h3>
            <p>Activity feed coming soon...</p>
          </div>
          <div className="dashboard-card">
            <h3>Upcoming Sessions</h3>
            <p>Session list coming soon...</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;